import { apiClient } from "./apiclient";

const getToken = () => localStorage.getItem("token");

export const getAllEmployees = () =>
  apiClient.get("/AllData", {
    headers: { Authorization: `Bearer ${getToken()}` },
  });

export const getAllDepartments = () =>
  apiClient.get("/departments", {
    headers: { Authorization: `Bearer ${getToken()}` },
  });

export const getDailyReports = () =>
  apiClient.get("/api/daily-report/all", {
    headers: { Authorization: `Bearer ${getToken()}` },
  });